var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    key: _vm.timer1,
    staticClass: "configureBox"
  }, [_c("top-title", {
    attrs: {
      background: true
    }
  }, [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t(_vm.CONFIGURENAME[_vm.configureObj.controlsMark])))])]), _vm.configureObj.controlsMark == "titleTop" ? _c("title-top", {
    attrs: {
      styleObj: _vm.configureObj.style,
      pageTitle: _vm.pageTitle
    },
    on: {
      itemChange: _vm.itemChange,
      pageTitleChange: _vm.pageTitleChange
    }
  }) : _vm._e(), _vm.configureObj.controlsMark == "navigation" ? _c("navigation", {
    attrs: {
      styleObj: _vm.configureObj.style,
      configureList: _vm.configureList
    },
    on: {
      itemChange: _vm.itemChange
    }
  }) : _vm._e(), _vm.configureObj.controlsMark == "mainDrawing" ? _c("mainDrawing", {
    attrs: {
      styleObj: _vm.configureObj.style,
      configureList: _vm.configureList
    },
    on: {
      itemChange: _vm.itemChange
    }
  }) : _vm._e(), _vm.configureObj.controlsMark == "product" ? _c("product", {
    attrs: {
      styleObj: _vm.configureObj.style,
      configureList: _vm.configureList
    },
    on: {
      itemChange: _vm.itemChange
    }
  }) : _vm._e(), _vm.configureObj.controlsMark == "clause" ? _c("clause", {
    attrs: {
      styleObj: _vm.configureObj.style,
      configureList: _vm.configureList
    },
    on: {
      itemChange: _vm.itemChange
    }
  }) : _vm._e(), _vm.configureObj.controlsMark == "guarantee" ? _c("guarantee", {
    attrs: {
      styleObj: _vm.configureObj.style,
      configureList: _vm.configureList
    },
    on: {
      itemChange: _vm.itemChange
    }
  }) : _vm._e(), _vm.configureObj.controlsMark == "claims" ? _c("claims", {
    attrs: {
      styleObj: _vm.configureObj.style
    },
    on: {
      itemChange: _vm.itemChange
    }
  }) : _vm._e(), _vm.configureObj.controlsMark == "information" ? _c("information", {
    attrs: {
      styleObj: _vm.configureObj.style,
      configureList: _vm.configureList
    },
    on: {
      itemChange: _vm.itemChange
    }
  }) : _vm._e(), _vm.configureObj.controlsMark == "bottomButton" ? _c("bottom-button", {
    attrs: {
      styleObj: _vm.configureObj.style,
      configureList: _vm.configureList,
      themeColor: _vm.themeColor
    },
    on: {
      itemChange: _vm.itemChange
    }
  }) : _vm._e(), _vm.configureObj.controlsMark == "informationConfirmation" ? _c("information-confirmation", {
    attrs: {
      styleObj: _vm.configureObj.style,
      configureList: _vm.configureList
    },
    on: {
      itemChange: _vm.itemChange
    }
  }) : _vm._e(), _vm.configureObj.controlsMark == "trial" ? _c("trial", {
    attrs: {
      styleObj: _vm.configureObj.style,
      configureList: _vm.configureList
    },
    on: {
      itemChange: _vm.itemChange
    }
  }) : _vm._e(), _vm.configureObj.controlsMark == "inform" ? _c("inform", {
    attrs: {
      styleObj: _vm.configureObj.style
    },
    on: {
      itemChange: _vm.itemChange
    }
  }) : _vm._e(), _vm.configureObj.controlsMark == "disclosureIcp" ? _c("disclosureIcp", {
    attrs: {
      styleObj: _vm.configureObj.style
    },
    on: {
      itemChange: _vm.itemChange
    }
  }) : _vm._e(), _vm.configureObj.controlsMark == "productList" ? _c("productList", {
    attrs: {
      styleObj: _vm.configureObj.style,
      configureList: _vm.configureList,
      chooseStyleArr: _vm.chooseStyleArr
    },
    on: {
      itemChange: _vm.itemChange
    }
  }) : _vm._e(), _vm.configureObj.controlsMark == "queryInfo" ? _c("queryInfo", {
    attrs: {
      styleObj: _vm.configureObj.style,
      configureList: _vm.configureList
    },
    on: {
      itemChange: _vm.itemChange
    }
  }) : _vm._e(), _vm.configureObj.controlsMark == "policyCancel" ? _c("policyCancel", {
    attrs: {
      styleObj: _vm.configureObj.style,
      configureList: _vm.configureList
    },
    on: {
      itemChange: _vm.itemChange
    }
  }) : _vm._e(), _vm.configureObj.controlsMark == "policyDetail" ? _c("policyDetail", {
    attrs: {
      styleObj: _vm.configureObj.style,
      configureList: _vm.configureList
    },
    on: {
      itemChange: _vm.itemChange
    }
  }) : _vm._e(), _vm.configureObj.controlsMark == "invoiceList" ? _c("invoiceList", {
    attrs: {
      styleObj: _vm.configureObj.style,
      configureList: _vm.configureList
    },
    on: {
      itemChange: _vm.itemChange
    }
  }) : _vm._e(), _vm.configureObj.controlsMark == "invoice" ? _c("invoice", {
    attrs: {
      styleObj: _vm.configureObj.style,
      configureList: _vm.configureList
    },
    on: {
      itemChange: _vm.itemChange
    }
  }) : _vm._e(), _vm.configureObj.controlsMark == "invoiceRecordList" ? _c("invoiceRecordList", {
    attrs: {
      styleObj: _vm.configureObj.style,
      configureList: _vm.configureList
    },
    on: {
      itemChange: _vm.itemChange
    }
  }) : _vm._e(), _vm.configureObj.controlsMark == "invoiceDetail" ? _c("invoiceDetail", {
    attrs: {
      styleObj: _vm.configureObj.style,
      configureList: _vm.configureList
    },
    on: {
      itemChange: _vm.itemChange
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };